import 'bootstrap/dist/css/bootstrap.css';
import { useState } from 'react';
import Spinner from '../../shared/spinner';
import ScrollToTopButton from '../../shared/scrollToTopButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import InputMask from 'react-input-mask';
import CustomAlert from '../../shared/customAlert';
import ProcessadoraCartaoService from '../../services/processadoraCartaoService';

// Interfaces para tipos
interface CancelamentoBody {
  numeroProposta: string;
}

interface CancelamentoOutput {
  returnCode: number;
  returnDescription: string;
}

interface CancelamentoError {
  returnCode: string;
  returnDescription: string;
}

function CancelamentoContaCartao() {
  const [alert, setAlert] = useState<{ message: string; type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);
  
  // ALTERADO: numeroProposta -> numeroProposta
  const [numeroProposta, setNumeroProposta] = useState(''); 
  
  const [resultadoSucesso, setResultadoSucesso] = useState<CancelamentoOutput | null>(null);
  const [resultadoErro, setResultadoError] = useState<CancelamentoError | null>(null);
  const [exibeResultado, setExibeResultado] = useState(false);

  // Instanciando o service
  const processadoraCartaoService = new ProcessadoraCartaoService();

  // Função de cancelamento real
  const cancelarConta = async () => {
    
    // Objeto de requisição (usando numeroProposta para o campo numeroProposta da interface)
    const requestBody: CancelamentoBody = { numeroProposta: numeroProposta }; 
    setLoading(true);
    setResultadoSucesso(null);
    setResultadoError(null);

    try {
      const response = await processadoraCartaoService.cancelaConta(requestBody);
      const data: CancelamentoOutput = response.data;

      setResultadoSucesso(data);
      setAlert({ message: 'A conta foi bloqueada com sucesso!', type: 'success' });
      setExibeResultado(true);
    } catch (err: any) {
      const errorCode = err.response?.data?.returnCode || err.response?.status?.toString() || '500';
      const errorDescription = err.response?.data?.returnDescription || 'Erro desconhecido ao tentar cancelar a conta.';

      setResultadoError({ returnCode: errorCode, returnDescription: errorDescription });
      setAlert({ message: `Erro no cancelamento: ${errorDescription}`, type: 'error' });
      setExibeResultado(true);

      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {alert && <CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />}

      <div className="position-relative m-md-3">
        {loading ? (
          <Spinner loading={loading} />
        ) : (
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-body">
              <div className="card-header">
                <strong>Cancelamento de Conta / Bloqueio de Cartão</strong>
              </div>

              <p style={{ marginTop: '15px', color: '#6c757d' }}>
                Para bloquear a conta, insira o <b>Número da Proposta</b> vinculado a ela.
              </p>

              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>
                      Número da Proposta <span style={{ color: 'red' }}>*</span> 
                    </label>
                    <InputMask
                      mask="9999"
                      type="text"
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'White' }}
                      value={numeroProposta} // ALTERADO: numeroProposta -> numeroProposta
                      onChange={(e) => setNumeroProposta(e.target.value.replace(/_/g, ''))} // ALTERADO: setnumeroProposta -> setNumeroProposta
                      placeholder="Ex: 1234"
                    />
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-md-4">
                  <button
                    className="input-group-btn"
                    id="App-button-cor-principal"
                    style={{
                      width: '80%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid LightGrey',
                      borderRadius: '5px',
                      height: '50px',
                      minWidth: '50px',
                    }}
                    onClick={cancelarConta}
                  >
                    <FontAwesomeIcon icon={faBan} style={{ color: 'White', fontSize: 'larger', marginTop: '5px' }} />
                    <strong style={{ color: 'White', marginLeft: '5px', fontSize: 'larger' }}> Bloquear Conta</strong>
                  </button>
                </div>
              </div>

              {exibeResultado && resultadoSucesso && (
                <>
                  <hr style={{ marginTop: '20px', marginBottom: '20px' }} />
                  <h4>
                    <strong>Status do Bloqueio (Sucesso - 200)</strong>
                  </h4>
                  <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-md-12">
                      <label>Mensagem de Retorno:</label>
                      <input
                        type="text"
                        readOnly
                        className="form-control form-control-sm brds"
                        value={resultadoSucesso.returnDescription}
                        style={{ backgroundColor: 'LightGrey' }}
                      />
                    </div>
                  </div>
                </>
              )}

              {exibeResultado && resultadoErro && (
                <>
                  <hr style={{ marginTop: '20px', marginBottom: '20px' }} />
                  <h4>
                    <strong>Status do Bloqueio (Erro - {resultadoErro.returnCode})</strong>
                  </h4>
                  <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-md-2">
                      <label>Código de Retorno:</label>
                      <input
                        type="text"
                        readOnly
                        className="form-control form-control-sm brds"
                        value={resultadoErro.returnCode}
                        style={{ backgroundColor: '#f8d7da', color: '#721c24' }}
                      />
                    </div>
                    <div className="col-md-10">
                      <label>Descrição:</label>
                      <input
                        type="text"
                        readOnly
                        className="form-control form-control-sm brds"
                        value={resultadoErro.returnDescription}
                        style={{ backgroundColor: '#f8d7da', color: '#721c24' }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      <ScrollToTopButton />
    </>
  );
}

export default CancelamentoContaCartao;